import React, { useContext, useState } from "react";
import { DescriptionContext } from "./Contexts/ContextProjectUsers";
import { Card,Typography,Collapse,Empty } from "antd";
import ReactHtmlParser from "react-html-parser";
const {Panel}=Collapse
const {Text}=Typography
const ProjectDescription = React.memo(function ({ projectId,isProjectActive}) {
    // const [openModal,setOpenModal]=useState(false)
    // const [stateModal, setStateModal] = useState(false);
    // const [descripciónData,setDescriptionData] = useState([]);
    const {
      descriptionProject = [],
      // getDescriptionProject,
      // setDescriptionProject,
    } = useContext(DescriptionContext);

    return(
        <>
        {descriptionProject!=null? 
          <Card style={{margin:10}}>
            <Collapse defaultActiveKey={['0']} onChange={(e)=>{console.log(e)}}>
              <Panel header="Resumen ejecutivo" key="1"> 
                <Text>{ReactHtmlParser(descriptionProject.summaryExecutive)}</Text>
              </Panel>
              <Panel header="Introducion" key="2"> 
                <Text>{ReactHtmlParser(descriptionProject.introduction)}</Text>
              </Panel>
              <Panel header="Antecedentes" key="3">
                <Text>{ReactHtmlParser(descriptionProject.background)}</Text> 
              </Panel>
              <Panel header="Caracterización del problema" key="4"> 
                <Text>{ReactHtmlParser(descriptionProject.problem)}</Text>
              </Panel>
              <Panel header="Objetivo de estudio" key="5">
                <Text>{ReactHtmlParser(descriptionProject.studyObject)}</Text> 
              </Panel>
              <Panel header="Objetivo general" key="6">
                <Text>{ReactHtmlParser(descriptionProject.generalObjetive)}</Text>  
              </Panel>
              <Panel header="Objetivos específicos" key="7"> 
                <Text>{ReactHtmlParser(descriptionProject.specificObjetive)}</Text>  
              </Panel>
              <Panel header="Campo de acción" key="8"> 
                <Text>{ReactHtmlParser(descriptionProject.fieldAction)}</Text>  
              </Panel>
              <Panel header="Plan de trabajo" key="9">
                <Text>{ReactHtmlParser(descriptionProject.workPlan)}</Text>   
              </Panel>
              <Panel header="Características epistemológicas y metodológicas" key="10"> 
                <Text>{ReactHtmlParser(descriptionProject.characteristic)}</Text>  
              </Panel>
              <Panel header="Resultados Aspirados" key="11"> 
                <Text>{ReactHtmlParser(descriptionProject.aspiredResult)}</Text>  
              </Panel>
              <Panel header="Impacto Esperado" key="12"> 
                <Text>{ReactHtmlParser(descriptionProject.expectedImpact)}</Text>  
              </Panel>
            </Collapse>
          </Card>
          :
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        }
        </>
    )

})

export default ProjectDescription